import { render, staticRenderFns } from "./DataViewPersonData.vue?vue&type=template&id=c738aa8a&"
import script from "./DataViewPersonData.vue?vue&type=script&lang=js&"
export * from "./DataViewPersonData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports